import React from 'react'

function Answer() {
  return (
    <div>
      Answer
    </div>
  )
}

export default Answer
